// LIBRARIES //
import React from 'react';
import MaterialCard from '@material-ui/core/Card';

const Card = ({ children }) => <MaterialCard>{children}</MaterialCard>;

export default Card;
